module.exports = __webpack_public_path__ + "static/img/sciserver_compute.c8a2c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sciserver_compute.png
// module id = TabH
// module chunks = 1